import React, { Suspense, lazy } from 'react';
import FinanceRouteFallback from './FinanceRouteFallback';

const FinanceDashboard = lazy(() => import('./pages/Dashboard'));
const EditReport = lazy(() => import('./pages/EditReport'));
const ReportCompletionSuccess = lazy(() => import('./pages/ReportCompletionSuccess'));

export const financeRoutes = [
  {
    path: 'finance',
    element: (
      <Suspense fallback={<FinanceRouteFallback />}>
        <FinanceDashboard />
      </Suspense>
    ),
  },
  {
    path: 'reports/:reportId/edit',
    element: (
      <Suspense fallback={<FinanceRouteFallback />}>
        <EditReport />
      </Suspense>
    ),
  },
  {
    path: 'reports/completed',
    element: (
      <Suspense fallback={<FinanceRouteFallback />}>
        <ReportCompletionSuccess />
      </Suspense>
    ),
  },
];